import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { FEATURE_FLAGS_PROVIDERS } from './Providers';
import diveFeatureFlagsProvider from './dive';
import alwaysTrueFeatureFlagsProvider from './alwaysTrue';
var featureFlagsStrategies = _defineProperty(_defineProperty({}, FEATURE_FLAGS_PROVIDERS.DIVE_PROVIDER, diveFeatureFlagsProvider), FEATURE_FLAGS_PROVIDERS.ALWAYS_TURE_PROVIDER, alwaysTrueFeatureFlagsProvider);
var FeatureFlagsProvider = function FeatureFlagsProvider(provider, playerId, handlerCallback) {
  return featureFlagsStrategies[provider](playerId, handlerCallback);
};
export default FeatureFlagsProvider;